import styled from 'styled-components';

const SwitchAndTooltipContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 5px;
    height: 40px;
    align-items: center;
`;

export default SwitchAndTooltipContainer;